export default "__VITE_ASSET__cf8c93a5__"